export default __webpack_public_path__ + "static/media/feb03.6fcb0b0f.jpg";